export default __webpack_public_path__ + "assets/images/d0db0cda8657e297640cab1e25c92c35.jpg";